<template>
  <div class="container station-edit-container">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="card-header-label col-6">
            <span>Editar estación</span>
          </div>
          <div class="card-header-action-buttons col-6">
            <ButtonComponent
              :buttonText="'Refrescar'"
              :buttonColor="colors.BLUE_COLOR_BUTTON"
              :buttonAction="refreshData"
            />
          </div>
        </div>
      </div>
      <SpeenComponent v-if="isLoading" style="padding: 5ch 0;"
        :isAutomatic="true"
        :ringWidth="14"
        :spinnerSize="15"
        :isverticalAligned="true"
      />
      <div class="card-body" v-else>
        <form @submit.prevent="submitForm">
          <div class="edit-station-section">
            <div class="form-group row">
              <div class="col-5">
                <label for="editStationCode">Código:</label>
                <input type="text" v-model="formData.station.code" class="form-control" id="editStationCode" required>
              </div>
              <div class="col-5">
                <label for="editStationDescrip">Descripción:</label>
                <input type="text" v-model="formData.station.descrip" class="form-control" id="editStationDescrip" required>
              </div>
              <div class="col-2">
                <label for="editStationLineLimiter" style="margin-bottom: 1ch;">Limita la línea de producción:</label>
                <label class="form-check form-switch">
                  <input type="checkbox" v-model="formData.station.line_limiter" class="form-check-input">
                </label>
              </div>
            </div>
          </div>
          <hr>
          <div class="form-actions">
            <ButtonComponent
              :buttonText="'Guardar'"
              :buttonColor="colors.GREEN_COLOR_BUTTON"
            />
          </div>
        </form>
        <hr>
        <div class="station-machines-header">
          <div class="row">
            <div class="station-machines-header-label col-2">
              <span>Máquinas</span>
            </div>
            <div class="station-machines-header-pagination col-8">
              <b-pagination 
                v-model="currentPage" 
                :total-rows="machines.length" 
                :per-page="perPage" 
                aria-controls="production-line-stations-table" 
                style="margin: 0"
                align="center" 
              />
            </div>
            <div class="station-machines-header-action-buttons col-2">
              <ButtonComponent
                :buttonText="'Nueva'"
                :buttonColor="colors.GREEN_COLOR_BUTTON"
                :buttonAction="openCreateMachineModal"
              />
            </div>
          </div>
        </div>
        <hr>
        <template>
          <b-table
            id="station-machines-table" 
            striped 
            hover 
            :items="machines" 
            :fields="fields" 
            responsive 
            :per-page="perPage" 
            :current-page="currentPage"
            >
            <template v-slot:cell(actions)="data">
                <ButtonComponent
                    :buttonText="'Editar'"
                    :buttonColor="colors.GREEN_COLOR_BUTTON"
                    :buttonAction="() => editMahine(data.item.id)"
                />
                <ButtonComponent
                    :buttonText="'Borrar'"
                    :buttonColor="colors.RED_COLOR_BUTTON"
                    :buttonAction="() => confirmDeleteMachine(data.item)"
                />
            </template>
          </b-table>
        </template>
      </div>
    </div>
    <transition name="slide-fade">
      <MachineCreateModal
        v-if="showCreateModal"
        :machine-types="machineTypes"
        :stationId="stationIdProp"
        @machine-created="refreshData"
        @close-modal="closeMachineCreateModal"
      />
      <ActionConfirmModal
        v-if="showActionConfirmModal"    
        :contentMessage="actionConfirmModalMessage"
        :closeModal="closeActionConfirmModal"
        :methodForProp="methodeForProp"
      />
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import ButtonComponent from '../../common/components/ButtonComponent.vue';
import Colors from '../../common/colors';
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import MachineCreateModal from '../components/MachineCreateModal.vue';
import ActionConfirmModal from '../../common/components/modals/ActionConfirmModal.vue';

export default {
  name: 'StationEdit',
  components: {
    ButtonComponent,
    SpeenComponent,
    MachineCreateModal,
    ActionConfirmModal,
  },
  data() {
    return {
      formData: {
        station:{ 
          code: '',
          descrip: '',
          line_limiter: false,
        },
      },
      machine: [],
      machines: [],
      machineTypes: [],
      isLoading: true,
      colors: Colors,
      perPage: 5,
      currentPage: 1,
      showCreateModal: false,
      showActionConfirmModal: false,
      actionConfirmModalMessage: '',
      methodeForProp: null,
      fields: [
        { key: 'descrip', label: 'Descripción', sortable: true },
        { key: 'actions', label: 'Acciones'},
      ],

    };
  },
  props: {
    stationIdProp: {
      type: Number,
      required: true,
    },
  },
  methods: {
    submitForm() {
      axios.put(`/api/station/${this.stationIdProp}`, this.formData)
        .then(response => {
          showCustomSuccessSweetAlert('Cambios guardados correctamente');
          this.refreshData();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
    },
    getStationData() {
      axios.get(`/api/station/${this.stationIdProp}/edit-vue-data`)
      .then(response => {
        this.machines = response.data.station.machines;
        this.formData.station = {
          code: response.data.station.code,
          descrip: response.data.station.descrip,
          line_limiter: response.data.station.line_limiter,
        }
        this.machineTypes = response.data.machineTypes;
      })
      .catch(error => {
        console.error(error);
        showCustomErrorSweetAlert(error.response.data);
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    editMahine(machineId) {
      window.location.href = `/machine/${machineId}/edit`;
    },
    confirmDeleteMachine(machine) {
      this.actionConfirmModalMessage = `¿Está seguro de que desea eliminar la máquina ${machine.descrip}?`;
      this.methodeForProp = () => {
        this.deleteMachine(machine.id)
      };
      this.openActionConfirmModal();
    },
    deleteMachine(machineId) {
      axios.delete(`/api/machine/admon/${machineId}`)
      .then(response => {
        this.getStationData();
        showCustomSuccessSweetAlert('Máquina eliminada correctamente');
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.closeActionConfirmModal();
        });
    },
    refreshData() {
      this.isLoading = true;
      this.getStationData();
    },
    openCreateMachineModal() {
      this.showCreateModal = true;
    },
    closeMachineCreateModal(){
      this.showCreateModal = false;
    },
    openActionConfirmModal(){
      this.showActionConfirmModal = true;
    },
    closeActionConfirmModal(){
      this.showActionConfirmModal = false;
    },
  },
  computed:{
    ...mapGetters(['userPermissions','userHasPermission', 'isUserSuperadmin']),
    closingMachineTypeId(){
      return this.machineTypes.find(machineType => machineType.descrip === 'Cerradora').id;
    },
    countingMachineTypeId(){
      return this.machineTypes.find(machineType => machineType.descrip === 'Bascula').id;
    },
    canUpdateStation(){
      return this.isUserSuperadmin;
    },
    canUpdateTopic(){
      return this.isUserSuperadmin;
    },
    canDeleteStation(){
      return this.isUserSuperadmin;
    },
    canDeleteTopic(){
      return this.isUserSuperadmin;
    },
    canViewTopics(){
      return this.isUserSuperadmin;
    },
    canChangeTopics(){
      return this.canDeleteTopic || this.canUpdateTopic;
    }
  },
  mounted() {
    this.getStationData();
  },
}
</script>